import store from '@/store/index'
import apiConfig from '@/api/api'

const { api } = apiConfig()

const appoperation = {
  namespaced: true,

  state: () => ({
    loading: false,
    InHouseOperationRegistrationSuccess: false,
    InHouseOperationRegistrationFailure: false
  }),

  getters: {
    _loading: state => state.loading,
    _InHouseOperationRegistrationSuccess: state =>
      state.InHouseOperationRegistrationSuccess,
    _InHouseOperationRegistrationFailure: state => state.InHouseOperationRegistrationFailure
  },

  mutations: {
    LOADING (state, value) {
      state.loading = value
    },
    InHouseOperation_REGISTRATION_SUCCESS (state, value) {
      state.InHouseOperationRegistrationSuccess = value
    },
    InHouseOperation_REGISTRATION_FAILURE (state, value) {
      state.InHouseOperationRegistrationFailure = value
    }
  },

  actions: {
    CreateInHouseOperation ({ commit, rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        api
          .post('/InHouseOperation/CreateInHouseOperation', payload, {
            headers
          })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            commit('LOADING', false)
            commit('InHouseOperation_REGISTRATION_SUCCESS', true)
            resolve(response)
          })
          .catch(error => {
            commit('LOADING', false)
            commit('InHouseOperation_REGISTRATION_FAILURE', true)
            reject(error)
          })
      })
    },
    UpdateInHouseOperation ({ commit, rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        api
          .post('/InHouseOperation/UpdateInHouseOperation', payload, {
            headers
          })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            commit('LOADING', false)
            commit('InHouseOperation_REGISTRATION_SUCCESS', true)
            resolve(response)
          })
          .catch(error => {
            commit('LOADING', false)
            commit('InHouseOperation_REGISTRATION_FAILURE', true)
            reject(error)
          })
      })
    },
    GetByIdInHouseOperation ({ commit, rootState, dispatch }, AppOperationId) {
      return new Promise((resolve, reject) => {
        commit('LOADING', true)
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        api
          .get(
            `/InHouseOperation/GetAllInHouseOperationByID?AppOperationId=${AppOperationId}`,
            { headers }
          )
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetAllInHouseOperations ({ rootState, commit, dispatch }) {
      return new Promise((resolve, reject) => {
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        commit('LOADING', true)
        api
          .get('/InHouseOperation/GetAllInHouseOperation', { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    }
  }
}

export default appoperation
